import { useCallback } from 'react';

import { SelectedFile } from '%hooks/usePickedFiles';
import { FileList } from '%components/Files';
import { PickButton } from './PickButton';

interface Props {
	files: SelectedFile[];
	maxFiles: number;
	onAdd: () => void;
	onRemove: (index: number) => void;
}

export const FilePicker = ({ files, onAdd, onRemove, maxFiles }: Props) => {
	const onRemovePres = useCallback((index: number) => () => onRemove(index), [onRemove]);

	if (files.length < 1) {
		return <PickButton onPress={onAdd} />;
	}

	return (
		<>
			<FileList files={files} onRemovePress={onRemovePres} />

			{files.length < maxFiles && <PickButton onPress={onAdd} />}
		</>
	);
};
